import { classed } from "@tw-classed/core";
import { withClassName } from "../../helpers";
import type { TextareaProps } from "./textarea.types";

const classedTextarea = classed(
  "block resize-none p-4 text-primary-900 placeholder:text-grey-500 placeholder:font-thin outline-none hover:bg-primary-50 border-2 rounded-lg border-grey-300 focus:border-primary-500 focus:border-2 transition placeholder-shown:border placeholder-shown:border-grey-500 disabled:bg-grey-100 disabled:border-grey-100 disabled:text-grey-300 disabled:pointer-events-none",
  {
    variants: {
      size: {
        medium: "h-32 text-base",
        large: "h-36 text-lg",
      },
      state: {
        error: "!border-error-600 bg-error-50",
        success: "!border-success-600 bg-success-50",
      },
    },
  },
);

export const getTextareaClass = withClassName((props: Pick<TextareaProps, "state" | "size">) => classedTextarea(props));
